import { Component, OnInit } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzTableQueryParams } from 'ng-zorro-antd/table';
import { RelatorioAlteracaoService } from 'src/app/services/relatorio-alteracao.service';

@Component({
    selector: 'app-previa-historico-alteracoes',
    templateUrl: './previa-historico-alteracoes.component.html',
    styleUrls: ['./previa-historico-alteracoes.component.css'],
    standalone: false
})
export class PreviaHistoricoAlteracoesComponent implements OnInit {
  //Table
  pageSize = 1;
  pageIndex = 1;
  total = 0;
  medicamentos = [];

  loading = false;

  constructor(
    private relatorioAlteracaoService: RelatorioAlteracaoService,
    private message: NzMessageService
  ) { }

  ngOnInit(): void {
  }

  onQueryParamsChange(params: NzTableQueryParams): void {
    this.loading = true;
    this.relatorioAlteracaoService.previa(params.pageIndex).subscribe((m: any) => {
      this.pageIndex = params.pageIndex;
      this.medicamentos = m.data.itens.data;
      this.total = m.data.itens.total;
      this.pageSize = m.data.itens.per_page;
      this.loading = false;
    });
  }

  excluir(id: any){
    this.loading = true;
    this.relatorioAlteracaoService.exclusaoItemPrevia(id).subscribe((data: any) => {
      this.loading = false;
      this.message.success('O medicamento foi removido da prévia com sucesso!');
      this.recarregar();
    });
  }

  recarregar(){
    this.loading = true;
    this.relatorioAlteracaoService.previa(1).subscribe((m: any) => {
      this.pageIndex = 1;
      this.medicamentos = m.data.itens.data;
      this.total = m.data.itens.total;
      this.pageSize = m.data.itens.per_page;
      this.loading = false;
    });
  }
}
